import { Col, Form, Input, Row } from "antd";
import React from "react";
export function AccessDataInformation({ getFieldDecorator, username }) {
    return (
        <Form layout="vertical">
            <Row gutter={16}>
                <Col xs={24} md={8} offset={8}>
                    <Form.Item label="Utilizador">
                        {getFieldDecorator("username", {
                            initialValue: username,
                        })(<Input disabled={true} placeholder="Utilizador" />)}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}
